import { render, staticRenderFns } from "./LevelSelector.vue?vue&type=template&id=24b00ab8&scoped=true&"
import script from "./LevelSelector.vue?vue&type=script&lang=js&"
export * from "./LevelSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b00ab8",
  null
  
)

export default component.exports